import React, { useState, useContext, useCallback } from "react"
import { RootContext } from 'RootContext';

//core components
import { DropzoneArea } from 'material-ui-dropzone'
import Button from '@material-ui/core/Button';
import CircularProgress from "@material-ui/core/CircularProgress"
import Checkbox from "@material-ui/core/Checkbox"
import FileSaver from "file-saver"
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from "@material-ui/core/FormControlLabel"
import Grid from "@material-ui/core/Grid"
import GetAppIcon from '@material-ui/icons/GetApp';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import Select from "@material-ui/core/Select"

//pegaso components
import ErrorUtils from "components/Tools/ErrorUtils"
import { fetchWithTokenPegasoTools } from "components/Fetch/tools-api-fetch"

// CSS 
import { useDropzoneAreaStyle, useGridStyle } from "styles/autocadConverter/autocadConverterCss"

export default function FromDXFToOMA() {
  const { t, apiUrlPegasoTools, access_token_pegaso_tools, refresh_token_pegaso_tools, setAccess_token_pegaso_tools } = useContext(RootContext)
  const [fetching, setFetching] = useState(false)
  const [fileChargedData, setFileChargedData] = useState([])
  const [forceBothSideConvertion, setForceBothSideConvertion] = useState(false)
  const [fileConverted, setFileConverted] = useState(undefined)
  const [fileName, setFileName] = useState("")
  const [isError, setIsError] = useState("")
  const [message, setMessage] = useState("")
  const [side, setSide] = useState("")
  const [selectedSide, setSelectedSide] = useState(false)

  const dropzoneClasses = useDropzoneAreaStyle()
  const gridClasses = useGridStyle()

  //Handler change del file inserito
  function handleChangeFile(files) {
    setFileName("")
    setMessage("")
    setIsError(false)
    setFileConverted(undefined)
    setFileChargedData(files)
  }

  //Post in PegasoTools per la conversione del file
  const convertDXFToOMA = useCallback(async () => {
    const formData = new FormData()
    formData.append("filedxf", fileChargedData[0])
    const url = `${apiUrlPegasoTools}/ShapeConverter/dxf-to-oma?side=${side}&forceBothSideConvertion=${forceBothSideConvertion}`
    await fetchWithTokenPegasoTools(url, {
      method: "POST",
      headers: {
        Accept: "text/plain",
      },
      body: formData,
      apiUrl_pegaso_tools: apiUrlPegasoTools,
      access_token_pegaso_tools: access_token_pegaso_tools,
      refresh_token_pegaso_tools: refresh_token_pegaso_tools,
      setAccess_token_pegaso_tools: setAccess_token_pegaso_tools
    })
      .then(response => {
        if (!response.ok) throw Error(response.status)
        else return response.text()
      })
      .then(result => {
        //let shape = Buffer.from(result, "base64").toString();
        let shape = result;
        var blob = new Blob([`${shape}`], {
          type: "text/plain;charset=utf-8",
        })
        var fileWithoutExtension = fileChargedData[0].name.split('.')
        setFileConverted(blob)
        setFileName(fileWithoutExtension[0])
        setMessage(t("10372").toUpperCase())
        setFetching(false)
      })
      .catch(err => {
        setMessage(t("10360").toUpperCase())
        setIsError(true)
        setFetching(false)
        ErrorUtils.errorLog(`${url} => convertDXFToOMA Error`, err.message)
      });
  }, [apiUrlPegasoTools, fileChargedData, forceBothSideConvertion, t, side, access_token_pegaso_tools, refresh_token_pegaso_tools, setAccess_token_pegaso_tools])


  //Handler click bottone converti
  const handleClickConvert = () => {
    setFetching(true)
    setMessage("")
    setFileName("")
    setIsError(false)
    convertDXFToOMA()
  }

  //Cambia field (checkbox)
  const handleChangeForceBothSideConvertion = (event, value) => {
    setForceBothSideConvertion(value)
  }

  //Handler click donwload file
  const downloadFileConverted = () => {
    FileSaver.saveAs(fileConverted, `${fileName}.oma`)
  }

  //Handler lato della lente
  const handleChangeSide = (event) => {
    setSide(event.target.value);
    setSelectedSide(true)
  };

  return (

    <Grid container spacing={2} className={gridClasses.cardMarginBottom}>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
      >

        {/*Selezione lato della lente*/}
        <Grid item xs={3} container alignItems="center">
          <Grid item xs={12}>
            <p align="center">
              <u>{t("10370").toUpperCase()}</u>
            </p>
          </Grid>
          <Grid item xs={12} align="center">
            <FormControl style={{ minWidth: 120 }}>
              <InputLabel>{t("10385").toUpperCase()}</InputLabel>
              <Select
                value={side}
                label="Age"
                onChange={handleChangeSide}
              >
                <MenuItem value={'R'}>{t("10351")}</MenuItem>
                <MenuItem value={'L'}>{t("10352")}</MenuItem>
                <MenuItem value={'B'}>{t("10369")}</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        {/*DropzoneArea per inserimento file*/}
        <Grid item xs={3}>
          {
            selectedSide ? (
              <DropzoneArea
                acceptedFiles={['.dxf']}
                dropzoneClass={dropzoneClasses.myDropZone}
                dropzoneParagraphClass={dropzoneClasses.dropZoneText}
                dropzoneText={t("10371")}
                filesLimit={1}
                onChange={handleChangeFile.bind(this)}
                maxFileSize={10000000}
                useChipsForPreview={true}
                showFileNamesInPreview={true}
              />
            ) : (null)
          }
        </Grid>

        {/*Bottone per conversione file*/}
        {
          selectedSide && fileChargedData.length > 0 ? (
            <Grid item xs={3} container alignItems="center">
              <Grid item xs={12} align="center">
                <p align="center">
                  <u>{t("10364").toUpperCase()}</u>
                </p>
              </Grid>
              {
                fetching ? (
                  <Grid item xs={12} align="center">
                    <CircularProgress size={42} style={{ color: "primary" }} />
                  </Grid>

                ) : (

                  <Grid item xs={12} align="center">
                    {side !== "B" ?
                      <Grid item xs={12} align="center">
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={forceBothSideConvertion}
                              onChange={handleChangeForceBothSideConvertion}
                              name="forceBothSideConvertion"
                            />
                          }
                          label={t("10468")}
                        />
                      </Grid> : null
                    }
                    <Grid item xs={12} align="center">

                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        onClick={handleClickConvert}
                        endIcon={<PlayCircleOutlineIcon />}
                        disabled={fileChargedData.length <= 0 || !selectedSide}
                        style={{ textAlign: "center" }}
                      >
                        {t("10365")}
                      </Button>
                    </Grid>
                  </Grid>

                )
              }
            </Grid>
          ) : (
            <Grid item xs={3} />
          )
        }

        {/*Bottone per scaricare file*/}
        <Grid item xs={3} container alignItems="center">
          <Grid item xs={12} align="center">
            <p align="center" style={{ color: isError ? 'red' : 'black' }}>
              <u>{message}</u>
            </p>
          </Grid>
          {
            fileName !== "" ? (
              <Grid item xs={12} align="center">
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  onClick={downloadFileConverted}
                  endIcon={<GetAppIcon />}
                >
                  {t("10366")}
                </Button>
              </Grid>
            ) : (
              null
            )
          }
        </Grid>
      </Grid>
    </Grid>

  )
}
